/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TConsultationRequestRequest,
  TConsultationRequestModel,
  IMappers,
  TConsultationRequestResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IStatusResponseSchema } from '../../entities/base/StatusResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createConsultationRequestModel(parameters: TConsultationRequestRequest): TConsultationRequestModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'e2e-deal-entrypoints',
    pathApi: '/v2/consultation-request/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IConsultationRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TConsultationRequestRequest;
}

export async function fetchConsultationRequest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IConsultationRequestOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TConsultationRequestResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createConsultationRequestModel(parameters),
    config,
  )) as FetchResponse<TConsultationRequestResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IStatusResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TConsultationRequestResponse>;
}
